import { api as apiClient } from "../../../../shared/axios";
import { API_URL } from "../../../../shared/config";
import useSWR from "swr";

const url = `${API_URL}/resource`;
const url_ = `${API_URL}/data-source`;

const fetcher = (url) => apiClient.get(url);

export class DataSourceMmgService {
  getbuildings(config) {
    const { params } = config;
    return apiClient.get(`${url}/config/building/`, { params });
  }

  getInputTypes(config) {
    const { params } = config;
    return apiClient.get(`${url}/config/type/`, { params });
  }

  getDirectories(config) {
    const { params } = config;
    return apiClient.get(`${url}/config/tree/`, { params });
  }

  getConfigures(config) {
    const { params } = config;
    return apiClient.get(`${url}/config/`, { params });
  }

  getServers(config) {
    const { params } = config;
    return apiClient.get(`${url}/source/`, { params });
  }

  getDataSource(config) {
    const { params } = config;
    return apiClient.get(`${url_}/transactions/server/`, { params });
  }

  getDevices(config) {
    const { params } = config;
    return apiClient.get(`${url_}/transactions/`, { params });
  }

  createConfig(config) {
    const { body } = config;
    return apiClient.post(`${url}/config/`, body);
  }

  getAssets(config) {
    const { id } = config;
    return apiClient.get(`${url_}/transactions/asset/${id}`);
  }

  getEmissions() {
    return apiClient.get(`${url_}/transactions/emission-list`);
  }

  createAsset(config) {
    const { body } = config;
    return apiClient.post(`${url_}/transactions/asset/`, body);
  }

  removeDataSource(config) {
    const { body } = config;
    return apiClient.post(`${url}/unsync/`, body);
  }

  removeConfig(config) {
    const { body } = config;
    return apiClient.post(`${url}/config/unlink/`, body);
  }

  getHistory(config) {
    const { id } = config;
    return apiClient.get(`${url_}/transactions/${id}/`);
  }

  getHistoryDetail(config) {
    const { id } = config;
    return apiClient.get(`${url_}/transactions/detail/${id}`);
  }

  updateHistoryDetail(config) {
    const { body, id } = config;
    // const id = body?.id;
    // delete id;

    return apiClient.patch(`${url_}/transactions/detail/${id}/`, body);
  }

  updateDetailsWasteTravelling (config) {
    const { body, id } = config;

    return apiClient.patch(`${url_}/transactions/detail-travelling-waste/${id}/`, body);
  }

  updateTransactionDetails(config) {
    const { body, id } = config;
    return apiClient.patch(`${url_}/transactions/details/${id}/edit/`, body);
  }

  getYears(config) {
    const { params } = config;
    return apiClient.get(`${url}/config/cycle/`, { params });
  }

  getBill(config) {
    const { params } = config;
    return apiClient.get(`${url}/config/cycle/`, { params });
  }

  uploadTransaction(config) {
    const { body } = config;
    const formData = new FormData();
    body.files.forEach((f) => {
      formData.append("files", f.file);
    });
    formData.append("plant_id", body.plant_id);
    formData.append("company_id", body.company_id);
    formData.append("model", body.model);
    if(body.active_date){
      formData.append('date', body.active_date);
    }
    return apiClient.post(`${url_}/uploads/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  assignFirstMonth(config) {
    const { id } = config;
    return apiClient.post(`${url_}/transactions/detail/${id}/first-month/`);
  }

  calculateWaterMeter(config) {
    const { id } = config;
    return apiClient.post(`${url_}/transactions/${id}/calculate/`);
  }

  registerServer(config) {
    const { body } = config;
    return apiClient.post(`${url_}/register-server/`, body)
  }

  deleteTransaction(config) {
    const { id } = config;
    return apiClient.delete(`${url_}/transactions/${id}/soft-delete/`);
  }
  
  exportTransactionFile(config) {
    const { id } = config;
    return apiClient.get(`${url_}/transactions/export/${id}/`, {
      responseType: 'blob'
    });
  }

  aliasTransaction(config) {
    const { params } = config;
    return apiClient.get(`${url_}/transactions/dropdown-alias-water-meter/`, { params });
  }

  getServerConfig(config) {
    const { params } = config;
    return apiClient.get(`${url_}/transactions/server/by-code/`, { params });
  }

  syncNow(config) {
    const { body, id } = config;
    return apiClient.post(`${url_}/transactions/${id}/drive/sync-now/`, body);
  }

  getListPlantPartner(config) {
    const { params } = config;
    return apiClient.get(`${url_}/transactions/plant-partner/`);
  }
}

export const useGetListPlantPartner = () => {
  const { data, error, mutate } = useSWR(
    `${url_}/transactions/plant-partner/`,
    fetcher
  );
  return {
    data: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}
